import mp from './commons-mapping.json'

// 使用 Vite 的 import.meta.glob 替代 Webpack 的 require.context
const mappingFiles = import.meta.glob('@/view/**/*field-mapping.json', { eager: true })

// 将扫描到的路由信息加入路由数组中
Object.keys(mappingFiles).forEach(modulePath => {
  const content = mappingFiles[modulePath].default
  for(let k in content){
    mp[k]=content[k];
    console.log("auto load mapping key:"+k)
  }
})

export default mp;
